/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import theme from '../../../db.json';
import { WrapperStatusFooter, StatusDiv, TitleStatusDiv } from '../../../components/WrapperStatusFooter';
import CardIndicesFooter from '../../../components/CardIndicesFooter';
import CardCalendarItem from '../../../components/CardCalendarItem';
import CardPrincipalIndicator from '../../../components/CardPrincipalIndicator';

export default function StatusFooter() {
  const [successDataFinance, setSuccessDataFinance] = useState(null);
  const [errorDataFinance, setErrorDataFinance] = useState(false);
  const [buttonShowOrHide, setButtonShowOrHide] = useState(true);
  const [dataSuccess, setDataSuccess] = useState(false);
  const themeColors = theme.theme.colors.systems;

  const handleFinance = () => {
    axios
      .get(process.env.REACT_APP_ACCESSKEY_LINK_API_FINANCE)
      .then((res) => setSuccessDataFinance(res.data))
      .catch((error) => setErrorDataFinance(error));
  };

  useEffect(() => {
    if (buttonShowOrHide && dataSuccess) {
      handleFinance();
      setButtonShowOrHide(false);
    }
  }, [buttonShowOrHide, dataSuccess]);

  return (
    <WrapperStatusFooter>
      <StatusDiv>
        <TitleStatusDiv>Agenda da Quinzena</TitleStatusDiv>
        <CardCalendarItem
          symbol="GP"
          date="01/09"
          description="Fechamento Folha"
          color={themeColors.NS.GestaoDePessoas}
        />
        <CardCalendarItem symbol="FS" date="05/09" description="Fechamento Fiscal" color={themeColors.NS.Fiscal} />
        <CardCalendarItem symbol="CO" date="07/09" description="PGTO Salários" color={themeColors.NS.Controladoria} />
        <CardCalendarItem symbol="CO" date="07/09" description="PGTO FGTS" color={themeColors.NS.Controladoria} />
        <CardCalendarItem
          symbol="FH"
          date="10/09"
          description="FUP Unimed 22435"
          color={themeColors.NS.FinanceiroHospitalar}
        />
      </StatusDiv>
      <StatusDiv>
        <TitleStatusDiv>Principais Indicadores</TitleStatusDiv>
        <CardPrincipalIndicator description="Fat. Acumulado Mês" value="R$ 292.733,11" isPositive={true} />
        <CardPrincipalIndicator description="Fat. Acumulado FY" value="R$ 20.341.996,23" isPositive={true} />
        <CardPrincipalIndicator description="Taxa EBITDA Realizado " value="19,35%" isPositive={true} />
        <CardPrincipalIndicator description="Taxa EBITDA Prevista " value="21,64%" isPositive={true} />
        <CardPrincipalIndicator description="Taxa Glosa FY " value="1,12%" isPositive={false} />
      </StatusDiv>
      <StatusDiv>
        <label>
          <p>Índices Macroeconômicos</p>
          {buttonShowOrHide && <button onClick={() => setDataSuccess(true)}>Mostrar Dados</button>}
        </label>
        {errorDataFinance && <p>Houve um erro ao buscar os dados</p>}
        {!errorDataFinance && successDataFinance !== null && (
          <div>
            <CardIndicesFooter
              type="coin"
              coinName={successDataFinance.results.currencies.USD.name}
              coinBuy={successDataFinance.results.currencies.USD.buy}
              coinSell={successDataFinance.results.currencies.USD.sell}
              coinVariation={successDataFinance.results.currencies.USD.variation}
            />
            <CardIndicesFooter
              type="coin"
              coinName={successDataFinance.results.currencies.EUR.name}
              coinBuy={successDataFinance.results.currencies.EUR.buy}
              coinSell={successDataFinance.results.currencies.EUR.sell}
              coinVariation={successDataFinance.results.currencies.EUR.variation}
            />
            <CardIndicesFooter
              type="stock"
              stockName={successDataFinance.results.stocks.IBOVESPA.name}
              stockPoints={successDataFinance.results.stocks.IBOVESPA.points}
              stockVariation={successDataFinance.results.stocks.IBOVESPA.variation}
            />
          </div>
        )}
      </StatusDiv>
    </WrapperStatusFooter>
  );
}
